

export const formatAudioOutput = (segments: any) => { 

    if (segments?.length > 0) { 

        let formattedText = ''; 

        segments.forEach((segment: any) => {

            const mins = Math.floor(segment.start / 60);
            const secs = Math.floor(segment.start % 60);
            const ms = Math.round((segment.start - Math.floor(segment.start)) * 100);

            const time = (mins > 0) ? 
                `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}:${ms.toString().padStart(2, '0')}`:  
                `${secs.toString().padStart(2, '0')}:${ms.toString().padStart(2, '0')}`; 

            // const formattedLine = `${time} ${segment.text} \n`; 

            const formattedLine = `${segment.text} \n`; 

            formattedText = `${formattedText}${formattedLine}`; 
            
        });

        return formattedText; 

    }; 

}; 